<modal-layout-middle [sideImage]="content.image"
                     (close)="close()">

    <!-- title -->
    <p class="h3 m-t-7 m-t-10-s"
       *iCms="'title' of content"
       text></p>

    <!-- subtitle 1 -->
    <p class="s2 m-t-7 m-t-9-s"
       *iCms="'subtitle1' of content; content: 'html'"></p>

    <!-- subtitle 2 -->
    <p class="s2 m-t-7 m-t-6-s"
       *iCms="'subtitle2' of content; content: 'html'"></p>

</modal-layout-middle>
